import React from "react";
import PropTypes from "prop-types";
import NextLink from "next/link";
import {
  concatenateQueryParams,
  isLocalURL,
} from "@gonoodle/gn-universe-utils";

import api from "../api";

const client = api();

const Link = React.forwardRef(function Link(
  {
    children,
    events,
    className,
    href,
    as,
    passHref,
    shallow,
    replace,
    isOpen,
    ...rest
  },
  forwardedRef,
) {
  const parsedHref = isLocalURL(href)
    ? href
    : concatenateQueryParams("/external-link-disclaimer", {
        href,
      });

  const onRouteChange = () => {
    events.forEach((event) => {
      client.trackAnalyticsEvents(event).catch(() => {});
    });
  };
  return (
    <NextLink
      href={parsedHref}
      as={as}
      passHref={passHref}
      shallow={shallow}
      replace={replace}
      {...rest}
      className={className}
      onClick={() => {
        onRouteChange();
        rest?.onClick?.();
      }}
      ref={forwardedRef}
      draggable={false}
    >
      {children}
    </NextLink>
  );
});

export default Link;

Link.propTypes = {
  href: PropTypes.string.isRequired,
  as: PropTypes.string,
  passHref: PropTypes.bool,
  replace: PropTypes.bool,
  shallow: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      event: PropTypes.string.isRequired,
      properties: PropTypes.shape({}).isRequired,
    }),
  ),
};

Link.defaultProps = {
  as: undefined,
  passHref: false,
  replace: false,
  shallow: false,
  events: [],
  className: undefined,
};
